<style lang="less">
.copy-success-tip {
  padding: 0;
  width: 200px;
  height: 36px;
  background: rgba(0, 0, 0, 0.6);
  border-radius: 3px;
  font-size: 14px;
  color: #ffffff;
  line-height: 21px;
  top: 285px;
}
.copy-success-tipM {
  padding: 0;
  width: 400px;
  height: 72px;
  background: rgba(0, 0, 0, 0.6);
  border-radius: 6px;
  font-size: 28px;
  color: #ffffff;
  line-height: 42px;
  // top: 570px;
}
.intermediate,
.intermediateM {
  width: 375px;
  height: auto;
  margin: auto;
  // background: url("/s/a/images/bg_body.png");
  background-color: #f5f5f5;
  background-size: 100% 100%;
  background-repeat: no-repeat;
  color: #696464;
  padding: 0px 0 50px 0;
  font-size: 12px;
  .loading {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    -webkit-transform: translate(-50%, -50%);
    z-index: 999;
  }
  .page {
    padding-top: 20px;
    .course {
      width: 335px;
      margin: auto;
      background-size: 100% 100%;
      text-align: center;
      font-size: 16px;
      position: relative;
      border-bottom-left-radius: 10px;
      border-bottom-right-radius: 10px;
      box-shadow: 0px 10px 25px 0px rgba(0, 0, 0, 0.08);
      overflow: hidden;
      .courseInfo {
        width: 100%;
        background: url('../../assets/images/a/bg_top.png');
        background-size: cover;
        text-align: center;
        padding: 42px 0;
        color: #fff;
        position: relative;
        .comma {
          position: absolute;
          top: 10px;
          right: 10px;
          width: 36px;
          height: 36px;
          background: url('../../assets/images/k/qr-img.png');
          background-size: 100% 100%;
          background-repeat: no-repeat;
          cursor: pointer;
        }
        .schoolName {
          position: absolute;
          top: 14px;
          left: 50%;
          margin-left: -107px;
          width: 215px;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
          text-align: center;
          font-size: 16px;
          z-index: 1;
        }
        .courseName {
          width: 280px;
          margin: auto;
          word-wrap: break-word;
          font-weight: bolder;
          // margin-top: 8px;
          font-size: 21px;
          line-height: 1.2;
        }

        .avatarImg {
          position: absolute;
          z-index: 1;
          bottom: -27px;
          left: 50%;
          width: 54px;
          height: 54px;
          border-radius: 6px;
          transform: translateX(-50%);
          overflow: hidden;
          img {
            width: 100%;
            height: 100%;
          }
        }
      }
      .courseTeacher {
        width: 295px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        margin: 5px auto 0;
        font-size: 16px;
        color: #bfe3d8;
        display: flex;
        justify-content: center;
        align-items: center;

        .teacherName {
          display: inline-block;
          max-width: 81px;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
          vertical-align: middle;
          text-align: left;
        }
        .duration {
          margin-left: 12px;
          display: inline-block;
          height: 24px;
          vertical-align: middle;
        }
      }
      .courseContent {
        font-size: 16px;
        color: #000;
        width: 100%;
        background-color: #fff;
        // background: url("../../assets/images/a/bg_border_cover_body.png");
        // background-size: 100% 100%;
        text-align: center;
        margin: auto;
        padding: 42px 0;
        position: relative;
        .tip {
          width: 284px;
          margin: auto;
          margin-top: 10px;
        }
        .copy {
          display: flex;
          align-items: center;
          width: 265px;
          margin: 25px auto 0;
          font-size: 15px;
          font-family: 'PingFangSC-Medium', 'PingFang SC';
          font-weight: 500;
          color: #000000;
          line-height: 21px;
          text-align: left;
          .courseId {
            font-size: 18px;
          }
          .copy-icon {
            margin-left: 43px;
            display: inline-block;
            width: 15px;
            height: 15px;
            background: url('../../assets/images/k/copy.png') center center no-repeat;
            background-size: 100% 100%;
            cursor: pointer;
          }
        }
        .download-tip {
          margin-top: 15px;
          font-size: 14px;
          color: #b1b1b1;
          cursor: pointer;
        }
      }
      .jumpPage {
        // padding-top: 5px;
      }
      .courseResultContent {
        padding-top: 63px;
        .resultImg {
          width: 121px;
          height: 99px;
          margin: auto;
          // margin-top:40px;
        }
        .context {
          text-align: center;
          font-size: 20px;
          color: #696464;
          margin-top: 20px;
          margin-bottom: 5px;
          font-weight: bolder;
        }
        .subtitle {
          width: 238px;
          margin: auto;
          color: #696464;
          margin-top: 16px;
        }
        span {
          text-align: center;
          font-size: 15px;
          color: #696464;
        }
        .submitBtn {
          margin-top: 30px;
        }
      }
    }
    .signUpByPhone {
      background-size: 100% 100%;
      text-align: center;
    }
    .introduction {
      text-align: center;
      width: 340px;
      margin: auto;
      margin-top: 24px;
      .title {
        background: url('../../assets/images/a/icon_dot.png');
        background-size: 100% 100%;
        background-repeat: no-repeat;
        position: relative;
        width: 278px;
        height: 19px;
        margin: auto;
        color: #fff;
        .bgtext {
          position: absolute;
          font-size: 40px;
          color: #eaeaea;
          font-weight: 300;
          left: 50%;
          top: -8px;
          transform: translateX(-50%);
          -webkit-transform: translateX(-50%);
        }
        .titleText {
          position: absolute;
          font-size: 28px;
          text-align: center;
          left: 50%;
          top: -11px;
          color: #333;
          transform: translateX(-50%);
          -webkit-transform: translateX(-50%);
        }
      }
      .whiteBoard {
        width: 100%;
        margin: auto;
        border-radius: 8px;
        padding: 23px 18px;
        background: #fff;
        box-shadow: 0px 15px 15px 0px rgba(0, 0, 0, 0.1);
        margin-top: 40px;
        word-wrap: break-word;
        word-break: break-all;
        img{
          max-width: 100% !important;
        }
        p {
          text-align: left;
          line-height: 1.5;
          img {
            max-width: 100% !important;
            text-align: center;
            display: inline-block;
          }
        }
      }
    }
  }
  .submitBtn {
    display: block;
    width: 270px;
    height: 40px;
    margin: auto;
    line-height: 40px;
    color: #fff;
    cursor: pointer;
    border-radius: 10px;
    font-size: 16px;
    -webkit-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;
    border: 0;
    outline: none;
    background-color: #009265;
    margin-top: 66px;
    // position: absolute;
    // z-index: 2;
    // left: 50%;
    // transform: translateX(-50%);
    // -webkit-transform: translateX(-50%);
  }
}
.intermediateM {
  position: absolute;
  width: 100vw;
  min-height: 100vh;
  padding: 0px 0 100px 0;
  background-position: 0px -1px;
  box-sizing: border-box;
  font-size: 24px;
  left: 0;
  right: 0;
  top: 0;
  .page {
    padding-top: 40px;
    .course {
      width: 670px;
      font-size: 32px;
      box-sizing: border-box;
      // padding-top: 56px;
      border-bottom-left-radius: 20px;
      border-bottom-right-radius: 20px;
      box-shadow: 0px 20px 50px 0px rgba(0, 0, 0, 0.08);
      .courseInfo {
        padding: 84px 0;
        .comma {
          top: 20px;
          right: 20px;
          width: 72px;
          height: 72px;
        }
        .schoolName {
          top: 28px;
          margin-left: -215px;
          width: 430px;
          max-height: 134px;
          font-size: 32px;
        }
        .courseName {
          width: 590px;
          font-size: 48px;
        }

        .avatarImg {
          bottom: -54px;
          width: 108px;
          height: 108px;
          border-radius: 12px;
        }
      }
      .courseTeacher {
        width: 590px;
        margin: 10px auto 0;
        font-size: 32px;
        .teacherName {
          max-width: 162px;
        }
        .duration {
          margin-left: 48px;
          height: 48px;
        }
      }
      .courseContent {
        font-size: 30px;
        padding: 84px 0;
        margin-top: -1px;
        .tip {
          width: 568px;
          margin-top: 5px;
          padding-bottom: 50px;
          border-bottom: 1px solid #e0e0e0;
        }
        .copy {
          width: 530px;
          margin: 50px auto 0;
          font-size: 30px;
          line-height: 42px;
          .courseId {
            font-size: 36px;
          }
          .copy-icon {
            margin-left: 86px;
            width: 30px;
            height: 30px;
          }
        }
        .download-tip {
          margin-top: 30px;
          font-size: 28px;
        }
      }
      .courseResultContent {
        padding-top: 125px;
        .resultImg {
          width: 242px;
          height: 198px;
          // margin-top:80px;
        }
        .context {
          font-size: 40px;
          margin-top: 40px;
          margin-bottom: 10px;
        }
        .subtitle {
          width: 476px;
          color: #696464;
          margin-top: 32px;
        }
        span {
          font-size: 30px;
        }
        .submitBtn {
          margin-top: 60px;
        }
      }
    }
    .signUpByPhone {
      // height:1200px;
    }
    .introduction {
      width: 680px;
      margin-top: 48px;
      .title {
        width: 556px;
        height: 38px;
        .bgtext {
          font-size: 80px;
          top: -16px;
        }
        .titleText {
          font-size: 56px;
          top: -22px;
        }
      }
      .whiteBoard {
        border-radius: 16px;
        padding: 46px 36px;
        box-shadow: 0px 30px 30px 0px rgba(0, 0, 0, 0.1);
        margin-top: 80px;
        font-size: 24px;
        img {
          max-width: 100% !important;
        }
      }
    }
  }
  .submitBtn {
    width: 540px;
    height: 80px;
    line-height: 80px;
    font-size: 32px;
    margin-top: 132px;
    border-radius: 8px;
  }
}
</style>
<template>
  <div v-if="ajaxReturn" :class="isMobile ? 'intermediateM' : 'intermediate'" @click="handle">
    <div class="page">
      <div class="course" :class="{ signUpByPhone: usePhone }">
        <div class="courseInfo">
          <p class="comma" @click="showDownloadImg"></p>
          <p class="schoolName">{{ courseInfo.schoolName ? courseInfo.schoolName : '-' }}</p>
          <p class="courseName text-2-lines">{{ courseInfo.courseName ? courseInfo.courseName : '-' }}</p>
          <div class="courseTeacher">
            <span>{{ $t('pubcourse.teachers') }}</span>
            <template v-for="(item, index) in courseInfo.teacherList">
              <span key="tag" v-if="courseInfo.teacherNum > 1 && index === courseInfo.teacherList.length - 1">、</span>
              <span :key="index" :class="{ teacherName: courseInfo.teacherNum >= 2 }">
                {{ item.teacherName || '--' }}
              </span>
            </template>
            <span v-if="courseInfo.teacherNum > 2" class="more">
              {{ $t('pubcourse.tip.more') }}
            </span>
          </div>
          <div class="avatarImg">
            <!-- 注意：courseLogo是由courseWare拼接的 -->
            <img :src="courseInfo.courseLogo | serverimg_url('', 'avatar')" :onerror="errorImg" class="avatar" />
          </div>
        </div>
        <!-- 报名 -->
        <!-- <div v-if="courseInfo.signUpStatus===''" -->
        <div v-if="courseInfo.signUpStatus === ''" class="courseContent" :style="{ paddingTop: isMobile ? '84px' : '42px' }">
          <!-- 手机号报名 -->
          <signUpByPhone v-if="usePhone" ref="signUpByPhone" @signUp="signUp" @routerTo="routerTo" :config="signUpByPhoneConfig">
          </signUpByPhone>
          <div v-else>
            <p class="tip" v-html="$t('pubcourse.clickSignUp')"></p>
            <p class="copy">
              <span>{{ $t('pubcourse.courseId') }}</span>
              <span class="courseId">{{ cno }}</span>
              <span class="copy-icon btn_copy_text" :data-clipboard-text="cno"></span>
            </p>
            <div class="submitBtn primary" @click="signUpNow">{{ $t('pubcourse.applyNow') }}</div>
          </div>
          <!-- <p v-if="!usePhone" data-id="classInDownLoad_auto" class="download-tip">
            <span v-html="$t('pubcourse.downLoadTip')"></span>
          </p> -->
          <template v-if="!usePhone">
            <!-- 支持下载的浏览器 -->
            <p v-if="isSupport" data-id="classInDownLoad_auto" class="download-tip">
              <span v-html="$t('pubcourse.downLoadTip')"></span>
            </p>
            <!-- 不支持下载的浏览器 -->
            <p v-else class="download-tip" @click="download">
              <span v-html="$t('pubcourse.downLoadTip')"></span>
            </p>
          </template>
        </div>
        <div v-if="courseInfo.signUpStatus === 'jumpPage'" class="courseContent jumpPage">
          <jumppage :cno="cno"></jumppage>
        </div>
        <!-- 课程解散 -->
        <div v-show="courseInfo.signUpStatus === 'courseDisband'" class="courseContent courseResultContent">
          <img class="resultImg" src="@/assets/images/a/tip_end.png" />
          <p class="context" v-html="$t('pubcourse.tip.disband')"></p>
          <p class="subtitle" v-html="$t('pubcourse.subtitle.downAndReady')"></p>
          <!-- 支持下载的浏览器 -->
          <div v-if="isSupport" data-id="classInDownLoad_auto" class="submitBtn primary">
            {{ $t('pubcourse.down') }}
          </div>
          <!-- 不支持下载的浏览器 -->
          <div v-else @click="download" class="submitBtn primary">{{ $t('pubcourse.down') }}</div>
        </div>
        <!-- 禁止加入-->
        <div v-show="courseInfo.signUpStatus === 'courseClose'" class="courseContent courseResultContent">
          <img class="resultImg" src="@/assets/images/a/tip_end.png" />
          <p class="context" v-html="$t('pubcourse.tip.closeOpen')"></p>
          <p class="subtitle" v-html="$t('pubcourse.subtitle.downAndReady')"></p>

          <!-- 支持下载的浏览器 -->
          <a v-if="isSupport" data-id="classInDownLoad_auto" class="submitBtn primary">
            {{ $t('pubcourse.down') }}
          </a>
          <!-- 不支持下载的浏览器 -->
          <div v-else @click="download" class="submitBtn primary">{{ $t('pubcourse.down') }}</div>
        </div>
        <!-- 报名满 -->
        <div v-show="courseInfo.signUpStatus === 'courseStuFull'" class="courseContent courseResultContent">
          <img src="@/assets/images/a/tip_end.png" class="resultImg courseEnd" />
          <p class="context">{{ $t('pubcourse.full') }}</p>
          <!-- 支持下载的浏览器 -->
          <div v-if="isSupport" data-id="classInDownLoad_auto" class="submitBtn primary">
            {{ $t('pubcourse.down') }}
          </div>
          <!-- 不支持下载的浏览器 -->
          <div v-else @click="download" class="submitBtn primary">{{ $t('pubcourse.down') }}</div>
        </div>
        <!-- 报名成功 -->
        <div v-show="courseInfo.signUpStatus === 'signUpSuccess'" class="courseContent courseResultContent signUpSuccess">
          <img src="@/assets/images/a/tip_success.png" class="resultImg courseEnd" />
          <p class="context">{{ $t('pubcourse.success') }}</p>
          <p class="subtitle" v-html="$t('pubcourse.subtitle.downAndinstall')"></p>
          <!-- 支持下载的浏览器 -->
          <div v-if="isSupport" data-id="classInDownLoad_auto" class="submitBtn primary">
            {{ $t('pubcourse.down') }}
          </div>
          <!-- 不支持下载的浏览器 -->
          <div v-else @click="download" class="submitBtn primary">{{ $t('pubcourse.down') }}</div>
        </div>
      </div>
      <!-- 机构简介 -->
      <div
        class="introduction"
        v-if="(courseInfo.signUpStatus === '' || courseInfo.signUpStatus === 'signUpSuccess') && courseInfo.schoolIntroduction"
      >
        <p class="title">
          <span class="bgtext">introduction</span>
          <span class="titleText">{{ $t('pubcourse.institution') }}</span>
        </p>
        <div class="whiteBoard" v-html="courseInfo.schoolIntroduction"></div>
      </div>
    </div>
    <van-loading v-if="$root.loading" class="loading" :size="isMobile ? 80 : 40" />
    <MaskBox v-if="showMask" :courseInfo="courseInfo" @hide-mask="hideDownloadImg" />
  </div>
</template>

<script>
import qs from 'qs'
import url from 'url'
import moment from 'moment'
import moment_format from '@/filters/moment_format'
import serverimg_url from '@/filters/serverimg_url'
import html_text_mobile from '@/filters/html_text_mobile'
import strCopy from '@/api/strcopy'
import signUpByPhone from '@/components/pubcourse/signup_byphone.vue'
import jumppage from '@/components/pubcourse/jumppage.vue'
import restful_pubcourse from '@/api/pubcourse/restful_pubcourse.js'
import ClipboardJS from 'clipboard'
import MaskBox from '@/components/pubcourse/DownloadImg.vue'

export default {
  components: {
    signUpByPhone,
    jumppage,
    MaskBox,
  },
  filters: {
    serverimg_url,
    moment_format,
    html_text_mobile,
  },
  data() {
    return {
      href: window.location.href,
      isMobile: window.browserVersion.mobile,
      cno: url.parse(window.location.href, true).query.cid,
      clientName: '',
      courseInfo: {
        courseId: '',
        courseLogo: '',
        schoolName: '',
        courseName: '',
        teacherList: [],
        teacherNum: 0,
        schoolIntroduction: '',
        signUpStatus: '',
      },
      usePhone: url.parse(window.location.href, true).query.usePhone,
      signUpByPhoneConfig: {
        courseId: '',
        cno: ''
      },
      deviceTypeUrl: '',
      inWeixin: false,
      errorNo: '',
      canClick: true,
      ajaxReturn: false,
      showMask: false,
      errorImg: 'this.src="' + require('@/assets/images/a/avatar_defalut.png') + '"',
    }
  },
  watch: {},
  methods: {
    strCopy: strCopy,
    routerTo(pageName) {
      this.$emit('routerTo', 'tippage')
    },
    handle() {
      if (this.$refs.signUpByPhone && this.$refs.signUpByPhone.optionList) {
        this.$refs.signUpByPhone.closeOptionList()
      }
    },
    changeMeta(shareDataConfig) {
      document.title = shareDataConfig.title

      var metaName = document.createElement('meta')
      metaName.setAttribute('itemprop', 'name')
      metaName.content = shareDataConfig.title
      document.head.appendChild(metaName)

      var metaImg = document.createElement('meta')
      metaImg.name = 'image'
      metaImg.setAttribute('itemprop', 'image')
      metaImg.content = shareDataConfig.imgUrl
      document.head.appendChild(metaImg)

      var metaDesc = document.createElement('meta')
      metaDesc.name = 'description'
      metaDesc.setAttribute('itemprop', 'description')
      metaDesc.content = shareDataConfig.desc
      document.head.appendChild(metaDesc)
    },
    getShareData(courseInfo) {
      let title = this.$t('pubcourse.share.title', {
        schoolName: courseInfo.schoolName,
        courseName: courseInfo.courseName,
      })
      let title2 = this.$t('pubcourse.share.title', {
        schoolName: courseInfo.schoolName,
        courseName: courseInfo.courseName,
      })
      var logo = courseInfo.courseLogo ? courseInfo.courseLogo : ''
      var shareDataConfig = {
        title: title,
        title2: title2,
        desc:
          courseInfo.teacherList[0].identify === 5
            ? this.$t('pubcourse.share.des', {
                courseName: courseInfo.courseName,
                teacherName: courseInfo.teacherList[0].teacherName,
              })
            : this.$t('pubcourse.share.desCourse', {
                courseName: courseInfo.courseName,
              }),
        imgUrl: courseInfo.courseLogo
          ? 'https://' + window.EEOENV.upload.ugcfile + courseInfo.courseLogo
          : 'https://static.eeo.cn/assets/images/weixin-share.png',
        link: window.location.href.replace(window.location.host, window.EEOENV.share.main),
      }
      document.title = title
      if (this.isMobile) {
        this.changeMeta(shareDataConfig)
      }
      window.eeoWxShare(shareDataConfig)
    },
    getPubcourseInfo() {
      this.$root.loading = true
      restful_pubcourse('getCourseInfo', {
        cno: this.cno,
      }).then((res) => {
        this.$root.loading = false
        var resData = res.data
        this.ajaxReturn = true
        if (resData) {
          if (typeof resData == 'number') {
            this.errorNo = resData
            switch (resData) {
              case 304:
                window.meaasgeAlert(this.$t('pubcourse.tip.institutionDisabled'))
                break
              case 104:
              case 147:
              case 149:
                this.$emit('routerTo', 'tippage', this.$t('pubcourse.tip.invalid'))
                break
            }
          } else {
            this.courseInfo = resData.courseInfo
            this.courseInfo.schoolIntroduction = html_text_mobile(resData.courseInfo.schoolIntroduction)
            this.signUpByPhoneConfig = {
              courseId: resData.courseInfo.courseId,
              cno: this.cno,
            }
            this.getShareData(resData.courseInfo)
          }
        }
      })
    },
    signUp(status) {
      this.courseInfo.signUpStatus = status
    },
    signUpNow() {
      if (this.courseInfo.courseName) {
        var url = 'classin://www.eeo.cn/enterclass?openCourseId=' + this.cno
        if (window.browserVersion.mobile) {
          this.browserMobile(url)
        } else {
          this.browserPc(url)
        }
      } else {
        this.isHascourseName()
      }
    },
    browserMobile(url) {
      if (!eeoRunWithoutWx()) {
        return
      }
      if (window.browserVersion.android) {
        window.location.href = url
        this.$root.loading = true
        setTimeout(() => {
          this.$root.loading = false
          window.location.href = window.location.href + '&usePhone=true'
        }, 3000)
      }
      if (window.browserVersion.ios) {
        var newUrl = window.location.href.replace('//share', '//static') + '&usePhone=true'
        setTimeout(() => {
          window.location.href = newUrl
        }, 200)
      }
    },
    browserPc(url) {
      this.courseInfo.signUpStatus = 'jumpPage'
      var callBack = () => {
        if (window.browserVersion.chrome) {
          window.location = url
        } else {
          var iframe = document.createElement('iframe')
          iframe.src = url
          // iframe.style.width ="0";
          // iframe.style.height="0";
          iframe.style.display = 'none'
          document.body.appendChild(iframe)
          this.$nextTick(() => {
            iframe.parentNode.removeChild(iframe)
          })
        }
      }
      eeoRunWithoutWx(callBack)
    },
    isHascourseName() {
      if (this.canClick) {
        switch (this.errorNo) {
          case 304:
            window.meaasgeAlert(this.$t('pubcourse.tip.institutionDisabled'))
            this.canClick = false
            setTimeout(() => {
              this.canClick = true
            }, 1000)
            break
        }
      }
    },
    getDevice() {
      var isiOS = window.browserVersion.ios
      var isAndroid = window.browserVersion.android
      if (isiOS) {
        this.deviceTypeUrl = 'https://itunes.apple.com/app/id1226361488?mt=8'
      } else if (isAndroid) {
        this.deviceTypeUrl = 'https://android.myapp.com/myapp/detail.htm?apkName=cn.eeo.classin&ADTAG=mobile'
      } else {
        this.deviceTypeUrl = 'https://www.eeo.cn/cn/download.html'
      }
    },
    isSupportIosVersion() {
      if (!window.browserVersion.ios) {
        return false
      }
      var ver = window.navigator.userAgent.toLowerCase().match(/os (.*?) like mac os/)
      if (!ver) {
        return true
      }
      var minVer = '9'
      var minVerArr = minVer.split('_')
      var currentVerArr = ver[1].split('_')
      var verLen = currentVerArr.length
      while (minVerArr.length < verLen) {
        minVerArr.push('0')
      }
      var isSupport = false
      // var i = 0;
      var compare = function (minVer, currentVer) {
        if (minVer < currentVer) {
          isSupport = true
        } else if (minVer > currentVer) {
          isSupport = false
        }
      }
      for (let i = 0; i < verLen; i++) {
        if (minVerArr[i] * 1 == currentVerArr[i] * 1) {
          if (i == verLen - 1) {
            isSupport = true
          } else {
            compare(minVerArr[i] * 1, currentVerArr[i] * 1)
          }
        } else {
          compare(minVerArr[i] * 1, currentVerArr[i] * 1)
          return isSupport
        }
      }
      return isSupport
    },
    download() {
      if (!window.eeoRunWithoutWx()) {
        return
      }
    },
    handlerCopy() {
      const clip = new ClipboardJS('.btn_copy_text')
      const tipClass = this.isMobile ? 'copy-success-tipM' : 'copy-success-tip'
      const copySuccess = this.$t('pubcourse.tip.copySuccess')
      clip.on('success', function () {
        window.vant.Toast({
          message: copySuccess,
          className: tipClass,
          // duration: 0,
        })
      })
    },
    showDownloadImg() {
      this.showMask = true
      document.body.style = `
        height: 100%;
        overflow: hidden;
      `
    },
    hideDownloadImg() {
      this.showMask = false
      document.body.style = `
        height: auto;
        overflow: auto;
      `
    },
  },
  computed: {
    isSupport() {
      let result = true
      let android = window.browserVersion.weixin && window.browserVersion.mobile && window.browserVersion.android
      let ios =
        (window.browserVersion.weixin && !this.isSupportIosVersion()) ||
        (window.browserVersion.mobile && window.browserVersion.ios && !(window.browserVersion.safari || window.browserVersion.weixin))
      result = android || ios
      return !result
    }
  },
  mounted() {
    this.getPubcourseInfo()
    //this.getDevice();
    this.clientName = this.$root.clientName
    this.inWeixin = window.navigator.userAgent.toLowerCase().match(/MicroMessenger/i) == 'micromessenger'
    if (this.usePhone) {
      var backUrl = window.location.origin + window.location.pathname + '?cid=' + this.cno
      eeoRunWithoutWx(false, window.location.href)
    }
    this.handlerCopy()
  },
}
</script>
